var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row section card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h2", { staticClass: "card-title" }, [
          _c("span", {
            staticClass: "heading-number heading-number-lg bg-primary",
            domProps: { textContent: _vm._s(_vm.number) }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.titleToString()))])
        ]),
        _vm._v(" "),
        _vm.showEdit || _vm.showDisplay
          ? _c(
              "div",
              { staticClass: "card-content" },
              [
                _c(
                  "b-collapse",
                  {
                    attrs: { id: _vm.iD(1) },
                    model: {
                      value: _vm.showEdit,
                      callback: function($$v) {
                        _vm.showEdit = $$v
                      },
                      expression: "showEdit"
                    }
                  },
                  [_vm._t("edit")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  {
                    attrs: { id: _vm.iD(2) },
                    model: {
                      value: _vm.showDisplay,
                      callback: function($$v) {
                        _vm.showDisplay = $$v
                      },
                      expression: "showDisplay"
                    }
                  },
                  [_vm._t("display")],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.showDisplay
      ? _c("div", { staticClass: "section-modify" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.modify()
                }
              }
            },
            [
              _vm._v(_vm._s(_vm.$t("Muokkaa")) + " "),
              _c("font-awesome-icon", { attrs: { icon: "edit" } })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showEdit &&
    _vm.proceedActionState != _vm.ActionState.Hidden &&
    _vm.showNextStepButton
      ? _c("div", { staticClass: "section-modify" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  return _vm.proceed()
                }
              }
            },
            [
              _vm._v(_vm._s(_vm.$t("Jatka")) + " "),
              _c("font-awesome-icon", { attrs: { icon: "angle-double-down" } })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }